// src/js/core/preferencesManager.js

const STORAGE_KEYS = {
  LANGUAGE: "site_language",
  LEVEL: "site_level",
  ACCENT_PREFERENCES: "site_accent_preferences",
};

const DEFAULT_PREFERENCES = {
  language: "spanish",
  level: "beginner",
  accentPreferences: {}, // Map of language to accent choice
};

// Get all preferences
export function getPreferences() {
  return {
    language: getLanguagePreference(),
    level: getLevelPreference(),
    accentPreferences: getAccentPreferences(),
  };
}

// Language preference
export function getLanguagePreference() {
  return localStorage.getItem(STORAGE_KEYS.LANGUAGE) || DEFAULT_PREFERENCES.language;
}

export function setLanguagePreference(language) {
  localStorage.setItem(STORAGE_KEYS.LANGUAGE, language);
}

// Level preference
export function getLevelPreference() {
  return localStorage.getItem(STORAGE_KEYS.LEVEL) || DEFAULT_PREFERENCES.level;
}

export function setLevelPreference(level) {
  localStorage.setItem(STORAGE_KEYS.LEVEL, level);
}

// Accent preferences
export function getAccentPreferences() {
  const saved = localStorage.getItem(STORAGE_KEYS.ACCENT_PREFERENCES);
  return saved ? JSON.parse(saved) : DEFAULT_PREFERENCES.accentPreferences;
}

export function getAccentPreference(language) {
  const preferences = getAccentPreferences();
  return preferences[language];
}

export function setAccentPreference(language, accentKey) {
  const preferences = getAccentPreferences();
  preferences[language] = accentKey;
  localStorage.setItem(STORAGE_KEYS.ACCENT_PREFERENCES, JSON.stringify(preferences));
}

// Initialize preferences with defaults if not set
export function initializePreferences() {
  if (!localStorage.getItem(STORAGE_KEYS.LANGUAGE)) {
    setLanguagePreference(DEFAULT_PREFERENCES.language);
  }

  if (!localStorage.getItem(STORAGE_KEYS.LEVEL)) {
    setLevelPreference(DEFAULT_PREFERENCES.level);
  }

  if (!localStorage.getItem(STORAGE_KEYS.ACCENT_PREFERENCES)) {
    localStorage.setItem(STORAGE_KEYS.ACCENT_PREFERENCES, JSON.stringify(DEFAULT_PREFERENCES.accentPreferences));
  }
}

// Clear all preferences
export function clearPreferences() {
  localStorage.removeItem(STORAGE_KEYS.LANGUAGE);
  localStorage.removeItem(STORAGE_KEYS.LEVEL);
  localStorage.removeItem(STORAGE_KEYS.ACCENT_PREFERENCES);
}
